import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-daterange-filter',
  templateUrl: './daterange-filter.component.html',
  styleUrls: ['./daterange-filter.component.sass'],
})
export class DaterangeFilterComponent implements OnInit {
  @Output() exportClick = new EventEmitter();
  @Output() filterChange = new EventEmitter();

  filter = new FormGroup({
    startDate: new FormControl(),
    endDate: new FormControl(),
  });

  constructor() {}

  ngOnInit(): void {}

  changeFilter() {
    const { startDate, endDate } = this.filter.value;
    this.filterChange.emit({ startDate, endDate });
  }

  exportReport() {
    this.exportClick.emit();
  }
}
